/*const journalItems = document.querySelectorAll('.journal__grid__item');
const rencontreItems = document.querySelectorAll(
  '.journal__grid__item[data-cat="rencontres"]'
);

const isAll = journalGrid.dataset.all === 'true';

const reOrderGrid = () => {
  const tmp = document.createElement('ul');
  let addedItems = 0;

  journalItems.forEach((item, index) => {
    const isRencontre = item.dataset.cat === 'rencontres';
    const isMiddle = index % 4 === 1 || index % 4 === 2;

    if (isMiddle) {
      if (addedItems <= rencontreItems.length - 1) {
        tmp.appendChild(rencontreItems[addedItems]);
        addedItems += 1;
        !isRencontre && tmp.appendChild(item);
      } else {
        !isRencontre && tmp.appendChild(item);
      }
    } else {
      !isRencontre && tmp.appendChild(item);
    }
  });

  journalGrid.innerHTML = tmp.innerHTML;
};*/

const journalGrid = document.querySelector('.journal__grid');

const msnry = new Masonry(journalGrid, {
  columnWidth: '.journal__grid__item',
  itemSelector: '.journal__grid__item',
  gutter: 56,
  fitWidth: true,
  horizontalOrder: true,
  percentPosition: true,
  containerStyle: {
    position: 'relative',
    width: '100%',
  },
  initLayout: true,
});

//msnry.layout();
//isAll && reOrderGrid();
//msnry.reloadItems();
//msnry.layout();
